import { useMemo, useEffect } from 'react'
import { type CompleteEvent, Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
import { Box } from '@mui/material'

interface Props {
  surveyJson: any
  onComplete: (survey: Model, options: CompleteEvent) => void
  onLoad?: (survey: Model) => void
}

export function SurveyDisplay ({
  surveyJson,
  onComplete,
  onLoad
}: Props): JSX.Element {
  const surveyModel = useMemo(() => {
    const model = new Model(surveyJson)

    model.onComplete.add(onComplete)

    return model
  }, [surveyJson, onComplete])

  useEffect(() => {
    onLoad?.(surveyModel)
  }, [surveyModel, onLoad])

  return (
    <Box sx={{ width: '100%' }}>
      <Survey model={surveyModel} />
    </Box>
  )
}
